import {AppDispatch} from "../../../store";
import {GameActionCreators} from "../../../store/reducers/game/action-creators";


export default class Turn{
    static async set(value, dispatch: AppDispatch){

        dispatch(GameActionCreators.setPlayerTurn(value));

    }
}

